<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <TheAside/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
const APIURL = process.env.VUE_APP_API_URL
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import axios from 'axios'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },
  beforeMount() {
    var devices;
    axios.get( APIURL+'/api1/devices', {   
      mode: 'no-cors',
          headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      withCredentials: false
    } )
    .then(  res => { 
        devices = res.data; 
        var newSel = []
        var newSel2 = []
        for (var x=0; x<devices.length;x++)
        {
            devices[x].filter = true;
            newSel.push(devices[x].serial)
            newSel2.push(devices[x].imei)
        }
        this.$store.commit('set', [ 'filterDevices', newSel ] )
        this.$store.commit('set', [ 'filterDevicesIMEI', newSel2 ] )        
      } )
    .catch( err => console.log(err))
    .finally(() => this.loading = false) 
   }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
